import { render, staticRenderFns } from "./CurtainUp.vue?vue&type=template&id=75fc0642&scoped=true&"
import script from "./CurtainUp.vue?vue&type=script&lang=js&"
export * from "./CurtainUp.vue?vue&type=script&lang=js&"
import style0 from "./CurtainUp.vue?vue&type=style&index=0&id=75fc0642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fc0642",
  null
  
)

export default component.exports